import {Injectable} from '@angular/core';
import {TkFile} from '../../interfaces/core/tk-file';
import {DeleteFileOptions, Directory, Filesystem} from '@capacitor/filesystem';
import {Platform} from '@ionic/angular';
import {FilesystemService} from './filesystem.service';
import {FileOpener, FileOpenerOptions} from '@capacitor-community/file-opener';


@Injectable({
  providedIn: 'root'
})
export class DocumentsService {

  constructor(private platform: Platform,
              private filesystemService: FilesystemService) {
  }

  /**
   *
   * @param tkFile
   */
  public async readDocument(tkFile: TkFile): Promise<string|Blob> {
    try {
      if (this.platform.is('hybrid')) {
        const readFile = await Filesystem.readFile({
          path: tkFile.filepath
        });
        return this.filesystemService.base64ToBlob(readFile.data as string, 'application/pdf');
      }
      else {
        const readFile = await Filesystem.readFile({
          path: tkFile.filepath,
          directory: Directory.Data
        });
        return `data:application/pdf;base64,${readFile.data}`;
      }
    }
    catch (error) {
      console.error('Fehler beim Lesen der PDF-Datei:', error);
      throw error;
    }
  }

  /**
   *
   * @param pdf
   * @param filename
   */
  public downloadDocument(pdf: string|Blob, filename: string): void {
    let link = document.createElement('a');
    if(this.platform.is('hybrid')) {
      pdf = pdf as Blob;
      link.href = URL.createObjectURL(pdf);
    }
    else {
      pdf = pdf as string;
      link.href = pdf;
    }

    link.download = filename;
    link.click();
  }

  /**
   *
   * @param tkFile
   * @param fileName
   */
  public async showDocument(tkFile: TkFile, fileName: string = (new Date()).getTime().toString() + '.pdf'): Promise<void> {
    if(this.platform.is('hybrid')) {
      const fileOpenerOptions: FileOpenerOptions = {
        filePath: tkFile.filepath,
        contentType: 'application/pdf'
      };
      await FileOpener.open(fileOpenerOptions);
    }
    else {
      const pdf = await this.readDocument(tkFile);
      this.downloadDocument(pdf, fileName);
    }
  }

  /**
   *
   * @param tkFile
   * @param data
   * @param path
   */
  public async saveDocument(
    tkFile: TkFile,
    data: any,
    path: string = null
  ): Promise<TkFile> {
    const fileName = this.filesystemService.generatePath(path) + new Date().getTime() + '.' + tkFile.format;

    const file = await Filesystem.writeFile({
      path: fileName,
      data: data,
      directory: Directory.Data,
      recursive: true,
      // encoding: encoding
    });

    if(this.platform.is('hybrid')) {
      tkFile.filepath = file.uri;
    } else {
      tkFile.filepath = fileName;
    }

    tkFile.loaded = true;
    return tkFile;
  }

  /**
   *
   * @param tkFile
   */
  public async deleteDocument(tkFile: TkFile): Promise<void> {
    if (tkFile.filepath) {
      const deleteFileOptions: DeleteFileOptions = {path: tkFile.filepath};
      if (!this.platform.is('hybrid')) {
        deleteFileOptions.directory = Directory.Data;
      }
      await Filesystem.deleteFile(deleteFileOptions);
    }
  }
}

